// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const NotificationWarning: React.FC<{ width?: number; height?: number }> = ({ width = 18, height = 17 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 18 17">
            <path
                fill="currentColor"
                d="M8.995 0c.527 0 .984.283 1.23.744l7.59 14.166a1.37 1.37 0 0 1-.035 1.417 1.368 1.368 0 0 1-1.195.673H1.405c-.491 0-.948-.248-1.194-.673a1.37 1.37 0 0 1-.035-1.417L7.766.744C8.012.284 8.468 0 8.996 0Zm0 5.95a.858.858 0 0 0-.843.85v3.967c0 .46.387.85.843.85.457 0 .844-.39.844-.85V6.8c0-.46-.387-.85-.844-.85Zm.95 7.65a.998.998 0 0 0-.458-.85.839.839 0 0 0-.984 0 .998.998 0 0 0-.456.85c0 .354.175.673.456.85a.839.839 0 0 0 .984 0 .998.998 0 0 0 .457-.85Z"
            />
        </svg>
    );
};

export default React.memo(NotificationWarning);
